export const isEmpty = (obj) => {
  for (const prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      return false;
    }
  }

  return true;
}

export const isMedMenu = () => {
  return sessionStorage.getItem("menuType") === "Medical";
}


export const priceCheck = (variant, discount, med_discount) => {
  let discountedTotal
  let selectedDiscount = discount
  let discount_type = discount?.coupon_type;
  let discount_amount = discount?.amount;
  let standard_price = variant.price_cents

  if(isMedMenu()){
    selectedDiscount = med_discount
    discount_type = med_discount?.coupon_type;
    discount_amount = med_discount?.amount;
    standard_price = variant.med_price_cents
  }

  // if(variant.price_cents !== variant.med_price_cents){debugger}

  if(discount_type === 'percent'){
    discountedTotal = (standard_price - (standard_price * discount_amount / 10000)) / 100
  } else if(discount_type === 'dollar') { discountedTotal = (standard_price - discount_amount) / 100 }
  else{ discountedTotal = discount_amount / 100}

  return {
    discountedTotal,
    selectedDiscount,
    standard_price
  }
}

/**
 * Checks if the current page is a WordPress domain.
 * @returns {Promise<boolean>} True if the current page is a WordPress domain, false otherwise.
 */

export async function isWordPress() {
  try {
    // Check /wp-json endpoint
    const wpJsonResponse = await fetch(`${window.location.origin}/wp-json`);
    if (wpJsonResponse.ok) {
      const data = await wpJsonResponse.json();
      if (data && data.namespaces) return true;
    }

    // Check headers
    const headResponse = await fetch(window.location.href, { method: "HEAD" });
    const poweredBy = headResponse.headers.get("X-Powered-By");
    if (poweredBy && poweredBy.includes("WordPress")) return true;

    // Check meta tags or HTML content
    const metaTag = document.querySelector('meta[name="generator"]');
    if (metaTag && metaTag.content.includes("WordPress")) return true;
    if (document.body.innerHTML.includes("wp-content")) return true;
  } catch (error) {
    console.error("Error checking WordPress domain:", error);
  }
  return false;
}
